// packages
import { NavLink } from "react-router-dom";

export default function Categories({
  data,
  title,
  path,
  param,
  imageCssClasses,
}) {
  return (
    <>
      {title && (
        <h2 className="mb-4 border-none text-center font-heading text-2xl md:text-3xl">
          {title}
        </h2>
      )}
      <div className="grid grid-cols-3 gap-y-4 md:grid-cols-6">
        {data.map((item, index) => {
          return (
            <NavLink
              className="group flex basis-1/4 flex-col items-center gap-2 overflow-hidden border-none text-gray-700 sm:basis-1/4 lg:basis-[8%]"
              key={index}
              to={`${path}?category=${item.code}`}
            >
              <img
                alt={item.name}
                className={`${imageCssClasses} h-full w-36 object-scale-down pt-1 transition-all duration-300 group-hover:scale-110`}
                src={item.image}
              />
              <p className="font-heading font-semibold transition-all duration-300 group-hover:translate-y-1">
                {item.name}
              </p>
            </NavLink>
          );
        })}
      </div>
    </>
  );
}
